/**
 * Creates CMS resource url for Bloomreach
 * Locale should be formatted with an underscore like: "en_GB"
 */ function createBloomreachResourceUrl(baseUrl, channel, resourceIds, locale) {
    if (!baseUrl || !channel) {
        throw new Error(`Failed to create Bloomreach CMS resource url. Need valid baseUrl and channel but got baseUrl: ${String(baseUrl)} and channel: ${channel} }`);
    }
    const localePath = locale ? `/${locale.replace('-', '_')}` : '';
    const queryParam = `?resourceBundleIds=${encodeURIComponent(resourceIds.join(','))}`;
    /**
   * If the base URL contains a channel and the "channel" argument exactly
   * matches that, the channel will be moved from after the base URL to the
   * end of the URL, before the query params.
   */ const url = baseUrl.includes(channel) ? baseUrl.replace(`/${channel}`, '') : baseUrl;
    return url + '/api/resources' + localePath + `/${channel}` + queryParam;
}

export { createBloomreachResourceUrl };
//# sourceMappingURL=create-resource-url.js.map
